import Vue from 'vue';
import VueRouter from 'vue-router';

import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import VueTheMask from 'vue-the-mask';

import App from '@/views/app';
import { i18n } from '@/core/i18n';
import { persist } from '@/core/persist';
import { tagManager } from '@/core/tag-manager';
import Constants from '@/constants';
import { AppVuetify as vuetify } from '@/theme';
import '@/core/filters/capitalize';
import '@/core/filters/uppercase';
import '@/core/payment-card/extend-card-types';
import { CULTURE_CONFIG } from './constants/culture';
import { parseQuery, stringifyQuery } from '@/core/helpers/routes';

Vue.config.productionTip = false;

Vue.use(VueI18Next);
Vue.use(VueTheMask);

const vueI18Next = new VueI18Next(i18next);

Vue.use(i18n.Plugins.VueCulture, CULTURE_CONFIG);

Vue.use(persist.Plugins.VueLocalStorage);
Vue.use(persist.Plugins.VueSessionStorage);
Vue.use(tagManager.Plugins.VueGoogleTagManager);
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: Constants.routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    parseQuery,
    stringifyQuery
});

new Vue({
    router,
    vuetify,
    i18n: vueI18Next,
    render: (h) => h(App)
}).$mount('#app');
